<template>
    <span>Redirecting...</span>
</template>

<script>
import Vue from 'vue';

export default ({
  created() {
    console.log('Redirecting to Outseta...');
    window.location.href = 'https://giraffepad.outseta.com/support/kb#/articles/bB9lElW8/how-do-i-get-help-';
  },
});
</script>
